import type { ReactNode } from "react";
import { useAuth } from "react-oidc-context";

/** Защищённый wrap: пускает только аутентифицированных. Если не вошёл —
 *  показывает prompt с кнопкой «Войти» (без авто-редиректа на IdP,
 *  чтобы пользователь сам решал когда логиниться). */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const auth = useAuth();

  if (auth.isLoading || auth.activeNavigator) {
    return (
      <div className="mt-home">
        <div className="mt-home__center">
          <p className="cl-min__sub">Проверяем авторизацию…</p>
        </div>
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="mt-home">
        <div className="mt-home__center">
          <div className="mt-empty mt-empty--error" role="alert">
            <h2 style={{ margin: "0 0 var(--sp-1)" }}>Ошибка авторизации</h2>
            <p style={{ margin: 0 }}>{auth.error.message}</p>
          </div>
          <div className="mt-home__cta">
            <button
              className="mt-btn mt-btn--secondary mt-btn--lg"
              onClick={() => {
                sessionStorage.setItem(
                  "mt:postLoginRedirect",
                  window.location.pathname + window.location.search,
                );
                void auth.signinRedirect();
              }}
              type="button"
            >
              Попробовать снова
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <div className="mt-home">
        <main className="mt-home__center">
          <div className="cl-min__hero">
            <h1 className="cl-min__h1">Требуется авторизация</h1>
            <p className="cl-min__sub">
              Войдите, чтобы продолжить.
            </p>
          </div>
          <div className="mt-home__cta">
            <button
              className="mt-btn mt-btn--primary mt-btn--lg"
              onClick={() => {
                sessionStorage.setItem(
                  "mt:postLoginRedirect",
                  window.location.pathname + window.location.search,
                );
                void auth.signinRedirect();
              }}
              type="button"
            >
              Войти
            </button>
          </div>
        </main>
      </div>
    );
  }

  return <>{children}</>;
}
